import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AppBaseComponent } from '../../app-base.component';

@Component({
  selector: 'app-execute-icon-button',
  templateUrl: './execute-icon-button.component.html',
  standalone: false,
})
export class ExecuteIconButtonComponent extends AppBaseComponent {
  @Input() isReadonly = false;
  @Output() triggered = new EventEmitter<boolean>();

  onClick(): void {
    this.triggered.emit(true);
  }
}